import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TrinityService } from '../services/trinity.service';
import { NotifierService } from 'angular-notifier';
import { CommonGridService } from 'src/app/shared/services/common-grid.service';

@Component({
  selector: 'app-trinity-list',
  templateUrl: './trinity-list.component.html',
  styleUrls: ['./trinity-list.component.scss']
})
export class TrinityListComponent implements OnInit, OnDestroy {

  public scrollDistance = 2;
  public throttle = 10;
  public searchValue = "";
  constructor( 
    private router: Router,
    public trinityService:TrinityService,
    public notifier:NotifierService,
    public cgService:CommonGridService
  ) {
    this.trinityService.headerSearchEvent.subscribe((searchText: string) => {
      this.onSearchChange(searchText);
    });
   }
  ngOnDestroy(): void {
    this.trinityService.trinityDashData = [];
    this.trinityService.trinityListPage = 1;
    this.searchValue = "";
    this.trinityService.isGlobalSearchShow = false;
  }

  ngOnInit(): void {
    this.trinityService.isGlobalSearchShow = true;
    this.trinityService.getTrinityDashboardData();

  }

  onSearchChange(str){
    this.searchValue = str;
    if(this.searchValue.length > 1){
      let query = {};
      query['search'] = this.searchValue;
      query['page'] = 1;
      this.trinityService.trinityDashData = [];
      this.trinityService.getTrinityDashboardData(query);
    }else{
      this.trinityService.getTrinityDashboardData({page:1});
    }
  }

  createQuote(){
    this.router.navigate(['/trinity/request']);
  }

  // downloadQuote(){
  //   this.trinityService.downloadQuote({"no_page":1}).subscribe((res:any) =>{
  //     res.blob();

  //   });



  downloadQuote(){
    this.trinityService.downloadQuote({"no_page":1}).subscribe((res:any) =>{
      if(res.status == 1){
        let data ={"headers":res.data[0],"data":res.data};
        this.cgService.jsonToCsvGenerator(data,'trinity_quote_list.csv');
      }else{
        this.notifier.notify('error',res.message);
      }
    });
  }

  getDynamicStyleHeader(){
    return this.trinityService.trinityDashHeader.map(() => '1fr').join(' ') + ' 1fr';
  }

  viewDetails(uuid){
    this.trinityService.trinityQuoteSaveId = uuid;
    this.trinityService.isPMFeasibilty = false;
    this.trinityService.trinityWidgetData = [];
    this.router.navigate(['/trinity/request/'+uuid]);
  }
  onScroll(){
    if( this.trinityService.trinityListPage == 1 || this.trinityService.trinityListPage < this.trinityService.trinityListTotalPage){
      this.trinityService.trinityListPage++;
      let query = {};
      if (this.searchValue && this.searchValue != "") {
        query['search'] = this.searchValue;
      }
      query['page'] = this.trinityService.trinityListPage;
      this.trinityService.getTrinityDashboardData(query);
    }
  }

}
